import React from "react";
import { injectIntl } from "react-intl";

const GoBack = (props) => {
  const { panel, updateState, intl } = props;
  const { formatMessage } = intl;

  const _goBack = () => {
    let events = props.currentState.events;
    let backStatus = props.currentState?.backStatus;
    const stepBack = backStatus.history?.pop();
    events["main"] = events[panel.allowBack.event];
    if (panel.allowBack.save) {
      events["main"].back = true;
    }

    updateState("backStatus", {
      history: backStatus?.history,
    });

    if (panel.allowBack.value === "useHistory" && stepBack) {
      updateState("primary", stepBack?.primaryState)
      events.main = stepBack?.event;
    } else {
      updateState(panel.allowBack.state, panel.allowBack.value);
    }

    updateState("events", events);
  };

  return (
    <div className="go-back" onClick={() => _goBack()}>
      <i className="fas fa-angle-left"></i>
      <span>
        {formatMessage({
          id: "back",
          defaultMessage: "back",
        })}
      </span>
    </div>
  );
};

export default injectIntl(GoBack);
